import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    servicioMedico: [],
  },

  getters: {
    getServicioMedico: (state) => state.servicioMedico,
  },

  mutations: {
    SET_SERVICIO_MEDICO(state, servicioMedico) {
      state.servicioMedico = servicioMedico;
    },
  },

  actions: {
    async fetchServicioMedico({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catServicioMedico')
        .then((response) => {
          commit('SET_SERVICIO_MEDICO', response.data.data);
        });
    },
  },
};
